<template>
  <active-bookings />
</template>

<script>
import ActiveBookings from "@/components/Ondemand/Bookings/ActiveBookings";
export default {
  components: {
    ActiveBookings,
  },
};
</script>

<style></style>
